<template>
  <div>
    <h1 class="title-page">
      <v-icon class="material-icons-outlined">import_contacts</v-icon>
      <br />連絡帳を製本
    </h1>

    <v-card class="card">
      <Overview
        @show-product-detail-full-screen-dialog="
          $emit('show-product-detail-full-screen-dialog')
        "
      />

      <section>
        <p class="sub-text">
          現在、カートに商品が入っています。<br />
          一度にご注文いただける商品は1種類のみです。<br />
          別の連絡帳製本を注文する場合は、現在の注文を完了させてから、再度ご注文ください。
        </p>

        <v-layout justify-center column pb-4 align-center>
          <v-btn
            class="v-btn--minwidth"
            color="primary"
            :to="{
              name: 'organizationCart',
              params: { organizationId, salesManagementId }
            }"
          >
            カートを見る
          </v-btn>

          <v-btn
            class="v-btn--minwidth"
            color="negative"
            :to="{ name: 'organizationTop', params: { organizationId } }"
          >
            園トップページへ
          </v-btn>
          <router-link :to="{ name: 'organizations' }" class="mt-3">
            園・施設の切り替え ≫
          </router-link>
        </v-layout>
      </section>
    </v-card>
  </div>
</template>

<script>
import { Kid } from "../../../../models/CombookBinding";
import { PropType } from "vue";
import Overview from "../Overview.vue";

export default {
  name: "AlreadyExistInCart",
  components: {
    Overview
  },
  props: {
    organizationId: {
      type: Number,
      required: true
    },
    salesManagementId: {
      type: Number,
      required: true
    }
  }
};
</script>

<style scoped>
.card {
  max-width: 443px;
}
.card section {
  padding: 16px;
}
.title-bar {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sub-text {
  font-size: 12px;
  color: #545454;
}
</style>
